import { persistStore } from 'redux-persist'
import { createStore, applyMiddleware, Store, compose } from 'redux'
import createSagaMiddleware from '@redux-saga/core'

import rootReducer from './modules/rootReducer'
import rootSaga from './modules/rootSaga'
import persistReducers from './persistReducers'
import { timerGuardMiddleware } from './middlewares/timerGuardMiddleware'
import { timerSyncMiddleware } from './middlewares/timerSyncMiddleware'

const sagaMiddleware = createSagaMiddleware()

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export const store: Store = createStore(
  persistReducers(rootReducer),
  composeEnhancers(applyMiddleware(timerSyncMiddleware, timerGuardMiddleware, sagaMiddleware))
)

export const persistor = persistStore(store)

sagaMiddleware.run(rootSaga)
